<template>
  <div class="text-left w-100">
    <div class="mt-4 mb-0 mb-md-6 w-100">
      <div class="d-flex align-center w-100">
        <h1
          class="my-2 text-h6 font-weight-black"
          :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 2rem !important;' : ''"
        >
          Voir les résultats de mes actions
        </h1>
      </div>
    </div>
    <div>
      <p>Cliquez sur une carte pour être redirigé vers la page de résultats</p>
    </div>
    <div class="mt-4">
      <ResultsPagination />
    </div>
  </div>
</template>

<script>
import ResultsPagination from "./ResultsPagination.vue"

export default {
  name: "ManageResults",
  components: {
    ResultsPagination,
  },
  data() {
    return {
      showCalendar: false,
      inProgress: false,
    }
  },
  methods: {
    fetchCurrentPage() {
      this.inProgress = true
      const urlQueryParams = { page: this.options.page }
      if (this.searchTerm) {
        urlQueryParams.recherche = this.searchTerm
      }
      this.$store
        .dispatch("fetchAction", { offset: this.offset, search: this.searchTerm })
        .then((response) => {
          this.actions = response
          this.actionCount = response.length
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
        .finally(() => {
          this.inProgress = false
        })
    },
  },
}
</script>
